import MVPReady from './MVPReady';
export default MVPReady;
